import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import { default as CommentBoxWithSuggestions } from './CommentBoxWithSuggestions';
import { default as CommentBoxWithSuggestionsNew } from '../CommentBoxWithSuggestions.editor_comment';
export default withFeatureBranch({
    editor_comment: CommentBoxWithSuggestionsNew
})(CommentBoxWithSuggestions);

//# sourceMappingURL=index.js.map